// Version 1: keep this algorithm stable so existing attempts retain their order.
export function randomizeChoiceOptions<T extends { value: string }>(
  options: readonly T[],
  submissionId: string | undefined,
  questionId: string,
  enabled: boolean | undefined,
  otherValue: string
): readonly T[] {
  if (!enabled || !submissionId || options.length < 2) return options;

  let state = 2166136261;
  const seed = JSON.stringify([submissionId, questionId]);
  for (let index = 0; index < seed.length; index += 1) {
    state = Math.imul(state ^ seed.charCodeAt(index), 16777619);
  }
  const nextRandom = () => {
    state = (state + 0x6d2b79f5) | 0;
    let value = Math.imul(state ^ (state >>> 15), 1 | state);
    value ^= value + Math.imul(value ^ (value >>> 7), 61 | value);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };

  // Shuffle label/value pairs together; Other is always pinned at the end.
  const shuffled = options.filter((option) => option.value !== otherValue);
  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const target = Math.floor(nextRandom() * (index + 1));
    [shuffled[index], shuffled[target]] = [shuffled[target], shuffled[index]];
  }
  return [
    ...shuffled,
    ...options.filter((option) => option.value === otherValue),
  ];
}
